/**
 * Types pour la numérotation séquentielle des pièces comptables (DGI/SYSCOHADA).
 *
 * Une `JournalSequence` est unique par (companyId, journalType, fiscalYearId)
 * et produit des numéros au format `${prefix}-${fiscalYearLabel}-${padded}`,
 * ex: `VTE-2026-000042`.
 *
 * Source: backend `apps/accounting-service/src/modules/journals/entities/journal-sequence.entity.ts`
 */

export type JournalSequenceType =
  | 'general'
  | 'sales'
  | 'purchases'
  | 'bank'
  | 'cash';

export interface JournalSequence {
  id: string;
  companyId: string;
  journalType: JournalSequenceType;
  fiscalYearId: string;
  fiscalYearLabel: string;
  prefix: string;
  currentSequence: number;
  padding: number;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateJournalSequenceConfiguration {
  prefix?: string;
  padding?: number;
}

/** Libellés français des types de journal pour l'affichage */
export const JOURNAL_TYPE_LABELS: Record<JournalSequenceType, string> = {
  sales: 'Ventes',
  purchases: 'Achats',
  bank: 'Banque',
  cash: 'Caisse',
  general: 'Opérations diverses',
};
